import React from 'react';
import styles from './ChildCard.module.css';
import ChildInfoOnCard from './ChildInfoOnCard';
import GlassCard from '../customs/GlassCard';

const SelectedChildCard = ({ child, onToggle }) => {
  return (
    <GlassCard
      onClick={() => onToggle(child)}
      className={styles.selectedChildCardInDialog}
    >
      <ChildInfoOnCard child={child} />
    </GlassCard>
  );
};

export default SelectedChildCard;
